import CircleButton from "@components/content/CircleButton";
import ConfirmableButton from "@components/content/ConfirmableButton";
import { ListActionProps } from "@components/layout/ModelIndex";
import React, { ReactNode } from "react";

export function renderItemActions<T>(
  item: T & { id?: string },
  listActions: ListActionProps<T>[]
): ReactNode[] {
  if (!item?.id) return [];

  return listActions.map((action, index) => {
    const { href = "#", needConfirm = false, confirmProps, onClick,
      isVisible: isVisibleFuntion, actionTitle, iconProps, target = "_self" } = action;
    const url = href.replace(/\{\:id\}/g, `${item.id}`);

    let isVisible = true;
    if (isVisibleFuntion && typeof isVisibleFuntion == "function") {
      isVisible = isVisibleFuntion(item);
    }
    if (!isVisible) {
      return null;
    }

    const handleClick = (e: React.MouseEvent) => {
      if (onClick) {
        e.preventDefault();
        onClick(`${item.id}`, item);
      }
    };

    if (needConfirm && confirmProps) {
      return (
        <ConfirmableButton
          key={`action-confirm-${index}`}
          {...confirmProps}
          onConfirm={handleClick}
          trigger={
            <CircleButton
              to={url}
              tooltip={actionTitle}
              iconProps={iconProps}
            />
          }
        />
      );
    } else {
      return (
        <CircleButton
          key={`action-${index}`}
          to={url}
          target={target}
          tooltip={actionTitle}
          iconProps={iconProps}
          onClick={handleClick}
        />
      );
    }
  });
}
